import React from "react";

export const imgHandler = (icon, bool, dark) => {
  switch (icon) {
    case "personal":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="user"
          style={{ height: "30px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
          ></path>
        </svg>
      );
    case "work":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="briefcase"
          style={{ height: "30px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
          ></path>
        </svg>
      );
    case "health":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="notes-medical"
          style={{ height: "30px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
          ></path>
        </svg>
      );
    case "groceries":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="shopping-cart"
          style={{ height: "26px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
          ></path>
        </svg>
      );
    case "shopping":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="store"
          style={{ height: "26px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 616 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
          ></path>
        </svg>
      );
    case "project":
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="lightbulb"
          style={{ height: "30px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 352 512"
        >
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
          ></path>
        </svg>
      );
    default:
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="pencil-alt"
          style={{ height: "30px" }}
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <defs>
            <linearGradient id="gradient">
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "blue" : "deepskyblue"}
                offset="10%"
              ></stop>
              <stop
                style={{ transition: "stop-color 500ms" }}
                stopColor={dark ? "cyan" : "navy"}
                offset="100%"
              ></stop>
            </linearGradient>
          </defs>
          <defs>
            <linearGradient id="bw">
              <stop stopColor="lightgray" offset="10%"></stop>
              <stop stopColor="dimgray" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            fill={bool ? "url(#bw)" : "url(#gradient)"}
            d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
          ></path>
        </svg>
      );
  }
};
